/**
 * External dependencies
 */
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles/createTheme';

export const FIT: SxProps<Theme> = {
  width: '100%',
  height: '100%',
  position: 'relative'
} as const;
export const FIT_WIDTH: SxProps<Theme> = {
  width: '100%',
  position: 'relative'
} as const;
export const FLEX_COLUMN: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column'
} as const;
export const SCROLL_CONTAINER: SxProps<Theme> = {
  height: '94%',
  overflowY: 'auto',
  overflowX: 'hidden',
  flexGrow: 1
} as const;
export const SCROLL_CONTAINER_NEW: SxProps<Theme> = {
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  flexGrow: 1
} as const;
export const FLEX_ALIGN_CENTER: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center'
} as const;
export const FLEX_ALIGN_END: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end'
} as const;
export const FLEX_JUSTIFY_START: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start'
} as const;
export const FLEX_JUSTIFY_END: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end'
} as const;
export const FLEX_JUSTIFY_CENTER: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center'
} as const;
export const FLEX_SPACE_BETWEEN_ALIGN_CENTER: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
} as const;
export const FLEX_ALL_CENTER: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
} as const;
export const FLEX_STAR: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center'
} as const;
export const FLEX_END: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end'
} as const;
export const SCROLL: SxProps<Theme> = {
  width: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  flexGrow: 1
} as const;
export const RESET: SxProps<Theme> = {
  minWidth: 'auto',
  minHeight: 'auto',
  margin: 0,
  padding: 0
} as const;
export const FLEX_ALIGN_START: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start'
} as const;
export const FLEX_START: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-start'
} as const;
export const FIXED_BOTTOM_RIGHT: SxProps<Theme> = {
  position: 'fixed',
  right: '0',
  bottom: '0',
  width: '100%'
} as const;
export const FIX_FULL_SCREEN: SxProps<Theme> = {
  position: 'fixed',
  left: 0,
  bottom: 0,
  width: '100%',
  height: '100%'
} as const;
